import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReviewFlights from './reviewFlights/ReviewFlights';
import TermsDialog from '../../components/review/termsAndConditions/TermsDialog';
import PrintPreview from '../../components/review/printPreview/PrintPreview';
import Dictionary from '../../model/Dictionary';
import Navigation from '../../components/navigation/Navigation';
import MainController from '../../controllers/MainController';
import Constants from '../../model/AppConfiguration';
import './ReviewScreen.css';

/**
 * ## Redux imports
 */
import * as globalActions from '../../redux/actions/GlobalActions';
import * as routesActions from '../../redux/actions/RoutesActions';
import * as flightsActions from '../../redux/actions/FlightsActions';
import * as passengersActions from '../../redux/actions/PassengersActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../redux/selectors/Index';

class ReviewScreen extends Component {
  static propTypes = {
    actions: PropTypes.object,
    general: PropTypes.object,
    isFetching: PropTypes.bool,
    routes: PropTypes.arrayOf(PropTypes.object),
    flights: PropTypes.arrayOf(PropTypes.object),
    passengers: PropTypes.arrayOf(PropTypes.object),
  };

  constructor (props) {
    super(props);

    const { passengers, actions } = props;

    this.state = {
      flights: [],
      passengers: passengers || [],
      showMealDetails: undefined,
      termsOpened: false,
    };

    actions.getFlights(Constants.REQUEST.REVIEW, props.reservationId);
  }

  toggleMealDetails = passengerId => {
    const { showMealDetails } = this.state;
    let newActive = showMealDetails && showMealDetails === passengerId ? undefined : passengerId;
    this.setState({ showMealDetails: newActive });
  };

  componentDidMount () {
    const { isFetching, routes, passengers, reservationId } = this.props;
    if (
      !isFetching &&
      routes &&
      routes.length &&
      reservationId &&
      (!passengers || !passengers.length)
    ) {
      this.props.actions.getPassengers(reservationId);
    }
  }

  componentWillReceiveProps (props) {
    const { isFetching, flights, routes, passengers } = props;
    let fullInfoFlights = flights;
    if (!isFetching && !routes) {
      this.props.actions.getRoutes();
    }
    if (routes && routes.length && passengers && passengers.length) {
      fullInfoFlights = selectors.flights.prepareFlightsForReview(flights, routes, passengers);
    }
    this.setState({ flights: fullInfoFlights });
  }

  openTerms = () => {
    this.setState({ termsOpened: true });
  };

  closeTerms = () => {
    this.setState({ termsOpened: false });
  };

  print = () => {
    const { general, actions } = this.props;
    actions.submitFlights(Constants.REQUEST.ACTION.PRINT, general);
  };

  submitData = step => {
    if (step === 'reservationsuccessful') {
      this.openTerms();
      this.setState({ step });
    } else {
      this.props.actions.submitFlights(
        Constants.REQUEST.REVIEW,
        this.props.general,
        this.state.flights,
        step
      );
    }
  };

  render () {
    const { flights, showMealDetails, termsOpened } = this.state;
    return (
      <Navigation
        submitData={this.submitData}
        screen={
          <div
            className='row review'
            id='mobile-container'
            style={{ height: MainController.showMobileVersion() ? 'initial' : 'calc(100% - 71px)' }}
          >
            <div className='col-12'>
              <div className='flights-review'>
                <div className='review-flights'>
                  <h1>{Dictionary.review.title}</h1>
                  <PrintPreview title={Dictionary.review.printTitle} onPrint={this.print} />
                </div>
              </div>
              <div className='flights-review'>
                <ReviewFlights
                  flights={flights}
                  toggleMealDetails={this.toggleMealDetails}
                  showMealDetails={showMealDetails}
                />
              </div>
              <TermsDialog
                termsOpened={termsOpened}
                onAcceptTerms={() =>
                  this.props.actions.submitFlights(
                    Constants.REQUEST.REVIEW,
                    this.props.general,
                    this.state.flights,
                    this.state.step
                  )
                }
                handleClose={this.closeTerms}
              />
              {/* <Button onClick={this.openTerms}>Submit</Button> */}
            </div>
          </div>
        }
      />
    );
  }
}

/**
 * ## Redux boilerplate
 */
const actions = [ globalActions, routesActions, passengersActions, flightsActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    general: selectors.general.getAll(state.general),
    reservationId: selectors.general.getReservationId(state.general),
    routes: selectors.routes.getRoutes(state.routes),
    passengers: selectors.passengers.getPassengers(state.passengers),
    flights: selectors.flights.getFlights(state.flights),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewScreen);



// WEBPACK FOOTER //
// ./src/containers/review/ReviewScreen.js